import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Button } from '@grandvisionhq/common';
import { Heading, Hr } from '@grandvisionhq/elements';
import { Alert } from '@grandvisionhq/iris-ui';
import AppointmentOverviewContainer from '../../../../components/AppointmentOverview/AppointmentOverviewContainer.js';

const CancelAppointmentConfirmation = (_param)=> {
    var { appointment , store , labels , returnPath , returnLabel , className  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "appointment",
        "store",
        "labels",
        "returnPath",
        "returnLabel",
        "className"
    ]);
    return React.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('cancel-appointment-confirmation', className)
    }), /*#__PURE__*/ React.createElement(Heading, {
        component: "h3",
        variant: "small",
        className: "cancel-appointment-confirmation__title"
    }, labels.title), /*#__PURE__*/ React.createElement(Hr, null), /*#__PURE__*/ React.createElement(Alert, {
        variant: "success",
        className: "alert-m-default cancel-appointment-confirmation__alert"
    }, labels.notification), /*#__PURE__*/ React.createElement(Heading, {
        variant: "smallest",
        className: ""
    }, labels.subtitle), /*#__PURE__*/ React.createElement(AppointmentOverviewContainer, {
        className: "cancel-appointment-confirmation__overview",
        appointment: appointment,
        store: store,
        isStoreLoading: false
    }), /*#__PURE__*/ React.createElement(Button, {
        variant: "outline",
        className: "cancel-appointment-confirmation__button",
        caption: returnLabel,
        href: returnPath
    }));
};

export { CancelAppointmentConfirmation as default };
//# sourceMappingURL=CancelAppointmentConfirmation.js.map
